class KeshRugColourLab extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.buttons = [...this.querySelectorAll('[data-colour-index]')];
    this.images = [...this.querySelectorAll('.kr-mto-colour-lab__image')];
    this.name = this.querySelector('[data-colour-label]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(Number(button.dataset.colourIndex)));
    });
    this.select(0);
  }

  select(index) {
    this.images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
    this.buttons.forEach((button, buttonIndex) => {
      const active = buttonIndex === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (this.name && this.buttons[index]) this.name.textContent = this.buttons[index].dataset.colourName;
  }
}

class KeshRugSizeLab extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.stage = this.querySelector('[data-size-stage]');
    this.label = this.querySelector('[data-size-label]');
    this.buttons = [...this.querySelectorAll('[data-ratio]')];
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
    if (this.buttons[0]) this.select(this.buttons[0]);
  }

  select(button) {
    if (!this.stage || !button) return;
    this.stage.style.setProperty('--ratio', `${button.dataset.ratio}%`);
    if (this.label) this.label.textContent = button.textContent.trim();
    this.buttons.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  }
}

if (!customElements.get('kr-colour-lab')) customElements.define('kr-colour-lab', KeshRugColourLab);
if (!customElements.get('kr-size-lab')) customElements.define('kr-size-lab', KeshRugSizeLab);
